/*
Author: Alexey Usov (dax@xdax.ru, https://t.me/doubleaxe, https://github.com/doubleaxe)
Please don't remove this comment if you use unmodified file
*/
import {Point, Rect} from '@/scripts/geometry';
import {injectSettings} from '@/scripts/settings';
import {useEventListener} from '@vueuse/core';
import {getScrollBox} from './commons';

export function useDragAndScroll() {
    const settings = injectSettings();
    let data: {
        mouse: Point;
        scroll: Point;
        scrollboxElement: HTMLElement;
        button: number;
    } | undefined = undefined;
    //fork fix: a right-button pan ends with a contextmenu event on
    //release — swallow any contextmenu until this timestamp so panning
    //the board never pops the browser menu (even if the pointer is
    //released outside the board)
    let suppressContextMenuUntil = 0;

    function startPan(event: PointerEvent) {
        //TODO user clicked on something else
        const {scrollboxElement} = getScrollBox(event.currentTarget as HTMLElement);
        if(!scrollboxElement)
            return;
        data = {
            mouse: Point.assign({x: event.clientX, y: event.clientY}),
            scroll: Point.assign({x: scrollboxElement.scrollLeft, y: scrollboxElement.scrollTop}),
            scrollboxElement,
            button: event.button,
        };
        if(event.button === 2)
            suppressContextMenuUntil = Date.now() + 1000;
    }

    function onStart(event: PointerEvent) {
        //fork change: a mouse drag on the board always pans, even if the
        //setting was toggled off or persisted off by the touch misdetection
        if(!settings.dragAndScrollEnabled && event.pointerType !== 'mouse') {
            data = undefined;
            return;
        }
        startPan(event);
    }

    //fork addition: right/middle-button pan — the user's explicit pan
    //gesture, so it always pans regardless of the drag-and-scroll
    //setting; same scroll math as onStart from here on
    function onStartPan(event: PointerEvent) {
        startPan(event);
    }
    function onMove(event: PointerEvent) {
        if(!data)
            return;
        const {mouse, scroll, scrollboxElement} = data;
        const mousePosition = Point.assign({x: event.clientX, y: event.clientY});
        if(!settings.dragAndScrollOutsideWindow) {
            const scrollBoxRect = Rect.assign(scrollboxElement.getBoundingClientRect());
            if(!scrollBoxRect.isPointInRect(mousePosition)) {
                return;
            }
        }
        const delta = Point.assign({x: event.clientX, y: event.clientY}).offsetBy(mouse, -1);
        const deltaScroll = scroll.offsetBy(delta, -1);
        if(deltaScroll.x >= 0)
            scrollboxElement.scrollLeft = deltaScroll.x;
        if(deltaScroll.y >= 0)
            scrollboxElement.scrollTop = deltaScroll.y;
    }
    function onStop(event: PointerEvent) {
        if(data?.button === 2)
            suppressContextMenuUntil = Date.now() + 250;
        data = undefined;
    }

    useEventListener(window, 'pointermove', onMove, {passive: true});
    useEventListener(window, 'pointerup', onStop, {passive: true});
    useEventListener(window, 'contextmenu', (event: Event) => {
        if(Date.now() < suppressContextMenuUntil) {
            event.preventDefault();
            event.stopPropagation();
        }
    }, {capture: true});

    return {
        onStart,
        onStartPan,
    };
}
